import certification9001White from '@/assets/images/certifications/iso-9001-white.svg';
import certification27001White from '@/assets/images/certifications/iso-27001-white.svg';
import certification9001Black from '@/assets/images/certifications/iso-9001-black.svg';
import certification27001Black from '@/assets/images/certifications/iso-27001-black.svg';
import useDevice from '@/hooks/useDevice';

import styles from './FooterCertifications.module.sass';
import { LANDING_LINKS } from '@/config/landing-links';
import { Link } from 'react-router-dom';

type CertificationsColor = 'white' | 'black';

interface FooterCertificationsProps {
  color?: CertificationsColor;
}

export const FooterCertifications = ({
  color = 'white',
}: FooterCertificationsProps) => {
  const { isMobile } = useDevice();

  const img9901 = {
    white: certification9001White,
    black: certification9001Black,
  }[color];

  const img27001 = {
    white: certification27001White,
    black: certification27001Black,
  }[color];

  const imgSize = isMobile ? 50 : 70;

  return (
    <div className={styles.certifications}>
      <Link to={LANDING_LINKS.CERTIFICATIONS_PAGE_URL} target="_blank">
        <img
          src={img9901}
          alt="ISO 9001:215"
          loading="lazy"
          width={imgSize}
          height={imgSize}
        />
      </Link>

      <Link to={LANDING_LINKS.CERTIFICATIONS_PAGE_URL} target="_blank">
        <img
          src={img27001}
          alt="ISO 27001:2022"
          loading="lazy"
          width={imgSize}
          height={imgSize}
        />
      </Link>
    </div>
  );
};
